import React from 'react';

interface IConditionalWrapperProps {
  condition?: boolean;
  wrapper?: (children: any) => React.ReactNode;
}

const ConditionalWrapper: React.FC<React.PropsWithChildren<IConditionalWrapperProps>> = ({
  condition,
  wrapper,
  children,
}) => {
  return condition ? <>{wrapper?.(children)}</> : <>{children}</>;
};
export default ConditionalWrapper;
